module.exports = __webpack_public_path__ + "img/10.6f3df3a0.jpg";